import React, { useState } from 'react';

import './styles.css';
import NumberSpinner from '../NumberSpinner';

type Props = {
  value: number;
  score: number;
  callback: any;
};

const Score = ({
  value,
  score,
  callback,
}: Props) => {
  const [total, setTotal] = useState<number>(0);

  function changeValue(value: number) {
    const change = value - total;
    console.log(value);
    setTotal(total + change);
    callback(change * score);
  }

  return (
    <div className={'score-value'}>
      <div className={'value'}>{value}</div>
      <div className={'score'}>({score})</div>
      <NumberSpinner
        min={0}
        value={total}
        onChange={changeValue}
      />
    </div>
  );
};

export default Score;